import { css } from '@/styled-system/css';

// Filled white circle with shadow so the buttons read clearly against listing
// photos / busy carousel backgrounds. Constellation's bare `tone="neutral"
// emphasis="filled"` defaults blend into the page background for our use case.
const navButtonBase = {
  position: 'absolute',
  bottom: '50%',
  zIndex: 1,
  bg: 'bg.neutral',
  boxShadow: 'md',
  transform: 'translate3d(0, 50%, 0)',
  _hover: { bg: 'bg.softest' },
} as const;

// Keep buttons inside the carousel so the nav affordance cannot widen the document.
export const prevButton = css({
  ...navButtonBase,
  left: '0',
});

export const nextButton = css({
  ...navButtonBase,
  right: '0',
});
